// extracted by mini-css-extract-plugin
export default {"sigWrapper":"styles_sigWrapper__TItxx","clearButton":"styles_clearButton__rlc0M"};